import { Button } from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  ShopLogo,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { useReturnRequest } from "@babackapp/return-widget-components/queries/use-return-requests";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";
import { ReturnContent } from "./return-content";
import { ReturnStatusTimeline } from "./return-status-timeline";
import { StatusAlert } from "./status-alert";
import { ReturnMethodSection } from "./return-method-section";

export function ReturnRequestDetails() {
  const { orderId, shopSlug, returnRequestId, logoUrl } = useWidgetParams();
  const t = useCustomText();
  const { data: returnRequest } = useReturnRequest({
    orderId,
    shopSlug,
    returnRequestId: returnRequestId!,
  });

  return (
    <WidgetPage className="pb-8">
      <Header>
        <ShopLogo src={logoUrl ?? undefined} />
        <HeaderTitle>
          <Link to="..">
            <Button variant="ghost">
              <ArrowLeft />
            </Button>
          </Link>
          {t("returnRequests.details.title")}
        </HeaderTitle>
        <HeaderDescription>
          {t("returnRequests.details.description")}
        </HeaderDescription>
      </Header>

      <ReturnContent returnRequest={returnRequest} />
      <StatusAlert status={returnRequest.status} shippingInfo={returnRequest.shipping_info} />
      <ReturnStatusTimeline status={returnRequest.status} />
      <ReturnMethodSection shippingInfo={returnRequest.shipping_info} />
    </WidgetPage>
  );
}
